/* Copyright (c) 2018 Scaper */

import * as React from "react";
import { IApi } from "../../api/api";
import { Estimate } from "../../estimate/estimate";

interface IProps {
    api: IApi;
}

export class Homeowner extends React.PureComponent<IProps, {}> {
    public render() {
        const { api } = this.props;
        return (
            <div className="container">
                <div className="section">
                    <h5>Learn More</h5>
                    <p>Stuff</p>
                </div>

                <div className="divider"></div>

                <div className="section">
                    <h5>Fresh cut grass right when you need it.</h5>
                    <p>Easy as a tap of a button.</p>
                    <p>On-demand.</p>
                    <p>Safety rating.</p>
                </div>

                <div className="divider"></div>

                <div className="section">
                    <h5>Meet Lando.</h5>
                    <p>Hailey loves Lando.</p>
                    <p>Support local business.</p>
                </div>

                <div className="divider"></div>

                <div className="section">
                    <h5>Hailey's Checklist.</h5>
                    <form>
                        <p>
                            <input type="checkbox" />
                            <label>Wrap birthday presents</label>
                        </p>
                        <p>
                            <input type="checkbox" />
                            <label>Get the cake</label>
                        </p>
                        <p>
                            <input type="checkbox" />
                            <label>Buy tiki torches</label>
                        </p>
                        <p>
                            <input checked={true} type="checkbox" />
                            <label style={{ textDecoration: "line-through" }}>Mow the lawn</label>
                        </p>
                    </form>
                </div>

                <div className="divider"></div>

                <Estimate api={api} />

                <div className="divider"></div>

                <div className="section">
                    <h5>How it works.</h5>
                    <p>Who is Scaper?</p>
                    <p>All in one App.</p>
                </div>
            </div>
        );
    }
}
